<template>
  <div class="prt_close_wrapper">
    <img src="../../assets/images/arrow.png" alt="Close" class="prt_close" :class="element">
  </div>
</template>

<script>
export default {
  name: "ButtonClose",
  props: ['element']
}
</script>

<style scoped>
img {
  position: fixed;
  right: 50px;
  top: 50px;
  cursor:pointer;
  z-index: 2;
}
.portfolio {
  transform: rotate(-90deg);
}
.about {
  transform: rotate(0);
}
.contact {
  transform: rotate(90deg);
}
.strength {
  transform: rotate(180deg);
}
</style>